import {computed} from 'vue';
import jsGlobalConfig from '@/bps/globals/jsGlobalConfig';

export default function useHighlightArticle(highlightArticleId: string) {
  const highlightArticleData = computed(() => {
    if (!highlightArticleId) {
      return null;
    }

    const highlightData = jsGlobalConfig().getHighlightArticleData(highlightArticleId);
    if (!highlightData) {
      return null;
    }

    const styles = {};
    const background = highlightData.backgroundColor;
    const color = highlightData.textColor;

    if (background) {
      styles['--highlight-background'] = background;
    }
    if (color) {
      styles['--highlight-color'] = color;
    }
    return {
      styles,
      text: highlightData.text,
      icon: highlightData.icon,
    };
  });

  return {highlightArticleData}
}


